
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ProteinIntakeGuidance() {
  const [userInfo, setUserInfo] = useState({
    age: '',
    weight: '',
    activityLevel: 'moderate',
    gender: 'male'
  });

  const [showRecommendation, setShowRecommendation] = useState(false);
  const [dailyProtein, setDailyProtein] = useState(0);

  const calculateProteinNeeds = () => {
    const { age, weight, activityLevel } = userInfo;
    
    if (!age || !weight) {
      alert('年齢と体重を入力してください');
      return;
    }

    const weightNum = parseFloat(weight);
    const ageNum = parseInt(age);
    
    let baseProtein = 1.0; // g/kg
    
    // 年齢による調整
    if (ageNum >= 65) {
      baseProtein = 1.2; // 高齢者は多めに
    }
    
    // 活動レベルによる調整
    switch (activityLevel) {
      case 'low':
        baseProtein *= 1.0;
        break;
      case 'moderate':
        baseProtein *= 1.1;
        break;
      case 'high':
        baseProtein *= 1.3;
        break;
    }

    const totalProtein = Math.round(weightNum * baseProtein);
    setDailyProtein(totalProtein);
    setShowRecommendation(true);
  };

  const proteinFoods = [
    {
      category: '肉類',
      items: [
        { name: '鶏胸肉（皮なし）', protein: 23, amount: '100g', calories: 108 },
        { name: '豚ヒレ肉', protein: 22.8, amount: '100g', calories: 115 },
        { name: '牛もも肉（赤身）', protein: 21.2, amount: '100g', calories: 140 }
      ]
    },
    {
      category: '魚類',
      items: [
        { name: 'サケ', protein: 22.3, amount: '100g', calories: 133 },
        { name: 'マグロ（赤身）', protein: 26.4, amount: '100g', calories: 125 },
        { name: 'サバ', protein: 20.7, amount: '100g', calories: 202 }
      ]
    },
    {
      category: '卵・乳製品',
      items: [
        { name: '卵', protein: 12.3, amount: '2個（100g）', calories: 151 },
        { name: 'ギリシャヨーグルト', protein: 10, amount: '100g', calories: 59 },
        { name: 'カッテージチーズ', protein: 13.3, amount: '100g', calories: 105 }
      ]
    },
    {
      category: '豆類',
      items: [
        { name: '納豆', protein: 16.5, amount: '1パック（50g）', calories: 100 },
        { name: '豆腐（木綿）', protein: 6.6, amount: '100g', calories: 72 },
        { name: '枝豆', protein: 11.7, amount: '100g', calories: 135 }
      ]
    }
  ];

  const proteinSupplements = [
    {
      name: 'ザバス ホエイプロテイン100',
      type: 'ホエイプロテイン',
      protein: 15,
      serving: '21g',
      price: '¥4,980',
      features: ['吸収が早い', '筋肉合成に効果的', '運動後に最適'],
      affiliate: 'https://rpx.a8.net/svt/ejp?a8mat=45BKFB+W5FG2+2HOM+BWGDT&rakuten=y&a8ejpredirect=https%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00u4624.2bo11ffa.g00u4624.2bo12bb6%2Fa25080201428_45BKFB_W5FG2_2HOM_BWGDT%3Fpc%3Dhttps%253A%252F%252Fitem.rakuten.co.jp%252Fbetaorido%252F3386-005962%252F%26amp%3Bm%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbetaorido%252Fi%252F10003003%252F%26amp%3Brafcid%3Dwsc_i_is_33f72da33714639c415e592c9633ecd7',
      image: 'https://thumbnail.image.rakuten.co.jp/@0_mall/betaorido/cabinet/amayahoo/08626834/3386-005962.jpg'
    },
    {
      name: 'ウイダー マッスルフィット プロテイン',
      type: 'ホエイ+カゼイン',
      protein: 14.2,
      serving: '20g',
      price: '¥4,713',
      features: ['持続的な吸収', 'EMR配合', '就寝前にも適している'],
      affiliate: 'https://rpx.a8.net/svt/ejp?a8mat=45BKFB+W5FG2+2HOM+BWGDT&rakuten=y&a8ejpredirect=https%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rzxd4.2bo1115c.g00rzxd4.2bo12fc2%2Fa25080201428_45BKFB_W5FG2_2HOM_BWGDT%3Fpc%3Dhttps%253A%252F%252Fitem.rakuten.co.jp%252Fsoukaidrink%252F4902888725166%252F%26amp%3Bm%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fsoukaidrink%252Fi%252F10004664%252F%26amp%3Brafcid%3Dwsc_i_is_33f72da33714639c415e592c9633ecd7',
      image: 'https://thumbnail.image.rakuten.co.jp/@0_mall/soukaidrink/cabinet/166/4902888725166.jpg'
    },
    {
      name: 'uFit Soy Protein ソイプロテイン',
      type: 'ソイプロテイン',
      protein: 17.1,
      serving: '25g',
      price: '¥4,280',
      features: ['植物性', 'イソフラボン含有', 'コスパ良好'],
      affiliate: 'https://rpx.a8.net/svt/ejp?a8mat=45BKFB+W5FG2+2HOM+BWGDT&rakuten=y&a8ejpredirect=https%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00u04a4.2bo11632.g00u04a4.2bo12ec4%2Fa25080201428_45BKFB_W5FG2_2HOM_BWGDT%3Fpc%3Dhttps%253A%252F%252Fitem.rakuten.co.jp%252Fufit-shop%252Fsoy-protein%252F%26amp%3Bm%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fufit-shop%252Fi%252F10000016%252F%26amp%3Brafcid%3Dwsc_i_is_33f72da33714639c415e592c9633ecd7',
      image: 'https://thumbnail.image.rakuten.co.jp/@0_mall/ufit-shop/cabinet/09680360/imgrc0098701504.jpg'
    },
    {
      name: 'DNS プロテインホエイ100',
      type: 'ホエイプロテイン',
      protein: 24.2,
      serving: '33g',
      price: '¥4,500-5,500',
      features: ['高タンパク質含有', 'アスリート向け', '溶けやすい'],
      affiliate: 'https://rpx.a8.net/svt/ejp?a8mat=45BKFB+W5FG2+2HOM+6C1VM&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2F0ea62065.34400275.0ea62066.204f04c0%2Fa25080201428_45BKFB_W5FG2_2HOM_6C1VM%3Fpc%3Dhttp%253A%252F%252Fwww.rakuten.co.jp%252F&m=http%3A%2F%2Fm.rakuten.co.jp%2F',
      image: 'https://public.readdy.ai/ai/img_res/6c70207f33b37ddc56b929479b7b77b0.jpg'
    }
  ];

  const mealPlans = [
    {
      meal: '朝食',
      foods: [
        { name: '卵2個', protein: 12.3 },
        { name: 'ギリシャヨーグルト100g', protein: 10 },
        { name: 'トースト1枚', protein: 3 }
      ],
      total: 25.3
    },
    {
      meal: '昼食',
      foods: [
        { name: '鶏胸肉100g', protein: 23 },
        { name: 'ご飯150g', protein: 3.8 },
        { name: 'サラダ', protein: 2 }
      ],
      total: 28.8
    },
    {
      meal: '間食',
      foods: [
        { name: 'プロテインドリンク', protein: 20 },
        { name: 'アーモンド20g', protein: 4 }
      ],
      total: 24
    },
    {
      meal: '夕食',
      foods: [
        { name: 'サケ100g', protein: 22.3 },
        { name: '納豆1パック', protein: 8.3 },
        { name: '豆腐100g', protein: 6.6 }
      ],
      total: 37.2
    }
  ];

  const intakeTips = [
    {
      icon: 'ri-time-line',
      title: '摂取タイミング',
      description: '運動後30分以内、就寝前、起床後にタンパク質を摂取すると効果的です。'
    },
    {
      icon: 'ri-scales-3-line',
      title: '分割摂取',
      description: '1回20-30gずつ、1日3-4回に分けて摂取することで吸収効率が向上します。'
    },
    {
      icon: 'ri-drop-line',
      title: '水分補給',
      description: 'タンパク質代謝には十分な水分が必要です。1日2L以上の水分摂取を心がけましょう。'
    },
    {
      icon: 'ri-leaf-line',
      title: 'バランス',
      description: '動物性と植物性タンパク質をバランスよく摂取することが重要です。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/sarcopenia/muscle-strength-assessment" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">筋力測定・評価</Link>
              <Link to="/sarcopenia/strength-training-guidance" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">筋力トレーニング</Link>
              <Link to="/sarcopenia/progress-monitoring" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">進捗モニタリング</Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-teal-600 cursor-pointer">ホーム</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/health-support" className="hover:text-teal-600 cursor-pointer">健康サポート</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900">タンパク質摂取指導</span>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-green-50 to-teal-50 py-16">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Nutritionist%20explaining%20protein%20intake%20to%20elderly%20patient%2C%20healthy%20protein-rich%20foods%20on%20table%20including%20fish%20meat%20eggs%20and%20beans%2C%20professional%20dietary%20consultation%2C%20modern%20healthcare%20setting%20with%20nutrition%20charts&width=1200&height=400&seq=protein-guidance-hero&orientation=landscape"
            alt="タンパク質摂取指導"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              タンパク質摂取指導
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              筋肉合成に必要なタンパク質の適切な摂取方法とタイミングをご指導します。個人の体重・活動レベルに合わせた最適な摂取量を算出し、効果的な食事プランをご提案いたします。
            </p>
          </div>
        </div>
      </section>

      {/* Protein Calculator */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">個人別タンパク質必要量計算</h2>
              <p className="text-lg text-gray-600">あなたに最適なタンパク質摂取量を算出します</p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">年齢</label>
                  <input
                    type="number"
                    value={userInfo.age}
                    onChange={(e) => setUserInfo(prev => ({ ...prev, age: e.target.value }))}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="例: 65"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">体重（kg）</label>
                  <input
                    type="number"
                    step="0.1"
                    value={userInfo.weight}
                    onChange={(e) => setUserInfo(prev => ({ ...prev, weight: e.target.value }))}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="例: 60.5"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">性別</label>
                  <div className="flex space-x-4">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="male"
                        checked={userInfo.gender === 'male'}
                        onChange={(e) => setUserInfo(prev => ({ ...prev, gender: e.target.value }))}
                        className="mr-2"
                      />
                      男性
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="female"
                        checked={userInfo.gender === 'female'}
                        onChange={(e) => setUserInfo(prev => ({ ...prev, gender: e.target.value }))}
                        className="mr-2"
                      />
                      女性
                    </label>
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">活動レベル</label>
                  <select
                    value={userInfo.activityLevel}
                    onChange={(e) => setUserInfo(prev => ({ ...prev, activityLevel: e.target.value }))}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm pr-8"
                  >
                    <option value="low">低活動（座位中心）</option>
                    <option value="moderate">中活動（軽い運動）</option>
                    <option value="high">高活動（定期的な運動）</option>
                  </select>
                </div>

                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-green-900 mb-2">活動レベルの目安</h4>
                  <ul className="text-sm text-green-800 space-y-1">
                    <li><strong>低活動:</strong> デスクワーク中心、運動習慣なし</li>
                    <li><strong>中活動:</strong> 週2-3回の軽い運動</li>
                    <li><strong>高活動:</strong> 週4回以上の定期的な運動</li>
                  </ul>
                </div>

                <button
                  onClick={calculateProteinNeeds}
                  className="w-full bg-teal-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  必要量を計算
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Recommendation Results */}
      {showRecommendation && (
        <section className="py-16 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">あなたの推奨タンパク質摂取量</h2>
                <div className="text-4xl font-bold text-teal-600 mb-2">{dailyProtein}g/日</div>
                <p className="text-lg text-gray-600">1回の食事で20-30gずつ、{Math.ceil(dailyProtein / 25)}回に分けて摂取することをお勧めします</p>
              </div>

              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center p-4 bg-blue-50 rounded-lg">
                  <div className="text-2xl font-bold text-blue-600 mb-2">{Math.round(dailyProtein * 0.4)}g</div>
                  <div className="text-sm text-blue-800">朝・昼・夕食</div>
                  <div className="text-xs text-blue-600">各食事での目安</div>
                </div>
                <div className="text-center p-4 bg-green-50 rounded-lg">
                  <div className="text-2xl font-bold text-green-600 mb-2">{Math.round(dailyProtein * 0.2)}g</div>
                  <div className="text-sm text-green-800">間食・補食</div>
                  <div className="text-xs text-green-600">プロテインドリンクなど</div>
                </div>
                <div className="text-center p-4 bg-orange-50 rounded-lg">
                  <div className="text-2xl font-bold text-orange-600 mb-2">30分以内</div>
                  <div className="text-sm text-orange-800">運動後摂取</div>
                  <div className="text-xs text-orange-600">筋合成のゴールデンタイム</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Protein Foods */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">高タンパク質食品一覧</h2>
            <p className="text-lg text-gray-600">効率的にタンパク質を摂取できる食品をカテゴリー別にご紹介</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {proteinFoods.map((category, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">{category.category}</h3>
                <div className="space-y-3">
                  {category.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="border-b border-gray-100 pb-3 last:border-b-0">
                      <div className="flex justify-between items-start mb-1">
                        <span className="font-medium text-gray-900 text-sm">{item.name}</span>
                        <span className="text-teal-600 font-bold text-sm">{item.protein}g</span>
                      </div>
                      <div className="flex justify-between text-xs text-gray-500">
                        <span>{item.amount}</span>
                        <span>{item.calories}kcal</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Protein Supplements */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">おすすめプロテインサプリメント</h2>
            <p className="text-lg text-gray-600">食事だけでは不足しがちなタンパク質を効率的に補給</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {proteinSupplements.map((supplement, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
                <img 
                  src={supplement.image}
                  alt={supplement.name}
                  className="w-full h-48 object-cover object-center"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-lg font-semibold text-gray-900">{supplement.name}</h3>
                    <span className="bg-teal-100 text-teal-800 text-xs px-2 py-1 rounded-full">
                      {supplement.type}
                    </span>
                  </div>
                  
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-2xl font-bold text-teal-600">{supplement.protein}g</span>
                    <span className="text-sm text-gray-500">{supplement.serving}あたり</span>
                  </div>

                  <div className="text-lg font-semibold text-gray-900 mb-3">{supplement.price}</div>

                  <div className="space-y-1 mb-4">
                    {supplement.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center text-sm text-gray-600">
                        <i className="ri-check-line text-green-500 mr-2"></i>
                        {feature}
                      </div>
                    ))}
                  </div>

                  <a
                    href={supplement.affiliate}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full bg-red-600 text-white text-center py-2 rounded-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    楽天で購入
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
            <div className="flex items-start">
              <i className="ri-information-line text-yellow-600 text-xl mr-3 mt-1"></i>
              <div>
                <h4 className="font-semibold text-yellow-800 mb-2">プロテイン選びのポイント</h4>
                <ul className="text-sm text-yellow-700 space-y-1">
                  <li>• ホエイプロテイン：吸収が早く、運動後に最適</li>
                  <li>• カゼインプロテイン：ゆっくり吸収、就寝前に適している</li>
                  <li>• ソイプロテイン：植物性、乳糖不耐症の方にも安心</li>
                  <li>• 人工甘味料や添加物の少ないものを選ぶ</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sample Meal Plan */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">1日の食事プラン例</h2>
            <p className="text-lg text-gray-600">タンパク質115gを効率的に摂取する食事例</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {mealPlans.map((meal, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                <div className="text-center mb-4">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{meal.meal}</h3>
                  <div className="text-2xl font-bold text-teal-600">{meal.total}g</div>
                </div>
                
                <div className="space-y-2">
                  {meal.foods.map((food, foodIndex) => (
                    <div key={foodIndex} className="flex justify-between items-center text-sm">
                      <span className="text-gray-700">{food.name}</span>
                      <span className="text-teal-600 font-semibold">{food.protein}g</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <div className="bg-teal-50 rounded-xl p-6 border border-teal-200">
              <h4 className="text-xl font-semibold text-teal-900 mb-2">1日の総タンパク質摂取量</h4>
              <div className="text-3xl font-bold text-teal-600">
                {mealPlans.reduce((total, meal) => total + meal.total, 0)}g
              </div>
              <p className="text-teal-700 mt-2">推奨摂取量を十分に満たしています</p>
            </div>
          </div>
        </div>
      </section>

      {/* Intake Tips */}
      <section className="py-16 bg-gradient-to-br from-teal-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">効果的な摂取のコツ</h2>
            <p className="text-lg text-gray-600">タンパク質の効果を最大化するための重要なポイント</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {intakeTips.map((tip, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 text-center">
                <div className="w-16 h-16 bg-teal-50 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${tip.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{tip.title}</h3>
                <p className="text-gray-600">{tip.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Related Links */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">関連プログラム</h2>
            <p className="text-lg text-gray-600">タンパク質摂取と合わせて実施することで、より効果的な結果が期待できます</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <Link to="/sarcopenia/strength-training-guidance" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 border border-gray-100 cursor-pointer">
              <div className="w-16 h-16 bg-orange-50 text-orange-600 rounded-lg flex items-center justify-center mx-auto mb-6">
                <i className="ri-fitness-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">筋力トレーニング指導</h3>
              <p className="text-gray-600 text-center mb-4">タンパク質摂取と運動の組み合わせで筋肉合成を最大化</p>
              <div className="text-center">
                <span className="text-orange-600 font-medium">詳細を見る →</span>
              </div>
            </Link>

            <Link to="/sarcopenia/progress-monitoring" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 border border-gray-100 cursor-pointer">
              <div className="w-16 h-16 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mx-auto mb-6">
                <i className="ri-line-chart-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">進捗モニタリング</h3>
              <p className="text-gray-600 text-center mb-4">栄養摂取状況と身体変化の記録・評価</p>
              <div className="text-center">
                <span className="text-blue-600 font-medium">詳細を見る →</span>
              </div>
            </Link>

            <Link to="/sarcopenia/muscle-strength-assessment" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 border border-gray-100 cursor-pointer">
              <div className="w-16 h-16 bg-purple-50 text-purple-600 rounded-lg flex items-center justify-center mx-auto mb-6">
                <i className="ri-pulse-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">筋力測定・評価</h3>
              <p className="text-gray-600 text-center mb-4">定期的な評価で栄養指導の効果を確認</p>
              <div className="text-center">
                <span className="text-purple-600 font-medium">詳細を見る →</span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">サルコペニア予防</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/sarcopenia/muscle-strength-assessment" className="hover:text-white cursor-pointer">筋力測定・評価</Link></li>
                <li><Link to="/sarcopenia/strength-training-guidance" className="hover:text-white cursor-pointer">筋力トレーニング指導</Link></li>
                <li><Link to="/sarcopenia/protein-intake-guidance" className="hover:text-white cursor-pointer">タンパク質摂取指導</Link></li>
                <li><Link to="/sarcopenia/progress-monitoring" className="hover:text-white cursor-pointer">進捗モニタリング</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">健康サポート</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">セルフケア支援</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/beast-blog" className="hover:text-white cursor-pointer">ビースト君ブログ</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職・派遣情報</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
